import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { identityLinkAction } from '../lib/identities';
import { buttonClass } from './ui/Button';

// One "Link <org> login" control (#466 § 2): a REAL form posting to the API's
// `/auth/org/:slug/link` leg as a top-level navigation, so the session cookie
// rides along and the IdP round-trip happens in the window. No body: the server
// binds the IdP-verified identity to the SESSION's user; the client names no
// subject (#1738 finding 1). Own file so the <form> is the template's root —
// happy-dom loses `form.nextSibling` (#481).

export function IdentityLinkForm(props: {
  /** The org's IdP slug (`MembershipView.sso.slug`). */
  readonly slug: string;
  /** The org's display login, for the button. */
  readonly org: string;
}): JSX.Element {
  return (
    <form method="post" action={identityLinkAction(props.slug)}>
      <button type="submit" class={buttonClass({ variant: 'outline', size: 'sm' })}>
        {t('logins.link_cta', { org: props.org })}
      </button>
    </form>
  );
}
